"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" };
const vue_i18n_1 = require("vue-i18n");
const ToggleItem_vue_1 = __importDefault(require("./ToggleItem.vue"));
const ocm_object_1 = require("@ocm/services/ocm-object");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DepartmentToggle',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const departmentsMap = new Map(ocm_object_1.country === "int"
            ? [
                ["women", t("siteWide.searchApp.department.women")],
                ["men", t("siteWide.searchApp.department.men")],
            ]
            : [
                ["damen", t("siteWide.searchApp.department.women")],
                ["herren", t("siteWide.searchApp.department.men")],
                ["kinder", t("siteWide.searchApp.department.kids")],
            ]);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_1, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(departmentsMap), ([key, label]) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ToggleItem_vue_1.default, {
                        key: key,
                        "department-type": key
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(label), 1)
                        ]),
                        _: 2
                    }, 1032, ["department-type"]));
                }), 128))
            ]));
        };
    }
});
